var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper",class:_vm.classObj},[_c('div',{class:{ 'fixed-header': _vm.fixedHeader }},[_c('navbar')],1),_c('sidebar',{staticClass:"sidebar-container"}),_c('div',{staticClass:"main-container",class:{ hasTagsView: _vm.needTagsView },staticStyle:{"padding-top":"90px"}},[_c('div',{staticClass:"tages",style:({
        width: _vm.isCollapse ? 'calc(100% - 210px)' : 'calc(100% - 50px)',
        left: _vm.isCollapse ? '230px' : '100px',
      })},[(_vm.needTagsView)?_c('tags-view'):_vm._e()],1),_c('app-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }